module.exports = __webpack_public_path__ + "static/media/coins.d2b477b8.svg";